import { createRouter as CreateRouterVue, 
         createWebHistory as  CreateWebHistoryVue} from 'vue-router'
import { RouteRecordRaw } from 'vue-router';
import { eAppPaths, eRolAppUsuario} from '@/core/model/GloblasEnum';
import {useServicesFactoryStore}  from '@/core/stores/services-factory-store';
import NotFound from '@/views/shared/NotFound.vue';
import LoginComponent from '@/components/login/LoginComponent.vue';
import HomeAdministracionComponent from '@/components/administracion/HomeAdministracionComponent.vue';
import HomeSocioComponent from '@/components/socio/HomeSocioComponent.vue';
import { ISesionApp } from '@/core/model/sesion/ISesionApp';

const RoutesRol = [
  {name:'home',Rol:[eRolAppUsuario.Empleado]}, //home 
  {name:'inicio',Rol:[eRolAppUsuario.Empleado]},    
  {name:'cuotas',Rol:[eRolAppUsuario.Empleado]},    
  {name:'cargos',Rol:[eRolAppUsuario.Empleado]},    
  {name:'tipoSocio',Rol:[eRolAppUsuario.Empleado]},    
  {name:'parametros',Rol:[eRolAppUsuario.Empleado]},    
  {name:'admins',Rol:[eRolAppUsuario.Empleado]},
  {name:'contratos',Rol:[eRolAppUsuario.Empleado]},
  {name:'listContratos',Rol:[eRolAppUsuario.Empleado]},
  {name:'contratoDetail',Rol:[eRolAppUsuario.Empleado]},
  {name:'listSocios',Rol:[eRolAppUsuario.Empleado]},
  {name:'socioDetail',Rol:[eRolAppUsuario.Empleado]},
  {name:'socioContrato',Rol:[eRolAppUsuario.Empleado]},  
  {name:'socioRecibos',Rol:[eRolAppUsuario.Empleado]},  
  {name:'socioRecibo',Rol:[eRolAppUsuario.Empleado]},  
  {name:'contratoRecibosList',Rol:[eRolAppUsuario.Empleado]},
  {name:'contratoReciboDetail',Rol:[eRolAppUsuario.Empleado]},
  {name:'contratoConveniosList',Rol:[eRolAppUsuario.Empleado]},
  {name:'contratoAgreementDetail',Rol:[eRolAppUsuario.Empleado]},
  {name:'socioDocumentos',Rol:[eRolAppUsuario.Empleado]},
  {name:'socioDocumento',Rol:[eRolAppUsuario.Empleado]},
  {name:'edocta',Rol:[eRolAppUsuario.Empleado]},
  {name:'ingresos',Rol:[eRolAppUsuario.Empleado]},
  {name:'fiscalparam',Rol:[eRolAppUsuario.Empleado]},
  {name:'invoicecfdi',Rol:[eRolAppUsuario.Empleado]},
  {name:'ej1',Rol:[eRolAppUsuario.Empleado]},    
  {name:'ej2',Rol:[eRolAppUsuario.Empleado]},

  {name:'socio',Rol:[eRolAppUsuario.Cliente]}, //home cliente
  {name:'miperfil',Rol:[eRolAppUsuario.Cliente]},
  {name:'info',Rol:[eRolAppUsuario.Cliente]}, 
  {name:'miscontratos',Rol:[eRolAppUsuario.Cliente]},
  {name:'contratoRecibosSocioList',Rol:[eRolAppUsuario.Cliente]}
];
const FreePaths =['newAdmin','newSocio'];

const routes: Array<RouteRecordRaw> = [  
    {
      name:'ini',
      path: '/',          
      component: LoginComponent
    },
    {
      name:'login',
      path:'/login',      
      component:LoginComponent
    },
    {
      name:'loginSocio',
      path:'/loginSocio',      
      component: () => import(/* webpackChunkName: "loginSocio" */ '../components/socio/LoginSocioComponent.vue') 
    },
    {
      name : 'newAdmin',
      path : '/newAdmin/:id',
      component: () => import(/* webpackChunkName: "newAdmin" */ '../components/employees/NewAdminComponent.vue') 
    },
    {
      name : 'newSocio',
      path : '/newSocio/:id',
      component: () => import(/* webpackChunkName: "newSocio" */ '../components/socio/NewSocioComponent.vue') 
    },
    {
      name:'home',    
      path:'/home',      
      component: HomeAdministracionComponent,
      children: 
      [ 
        { path: 'inicio',
          name:'inicio', 
          component: () => import(/* webpackChunkName: "homeMain" */ '../components/administracion/HomeMainComponent.vue') 
        },
        { path: 'cuotas',
          name:'cuotas', 
          component: () => import(/* webpackChunkName: "cuotas" */ '../components/tipoCuotas/IndexTipoCuotasComponent.vue') 
        }, 
        { path: 'cargos',
          name:'cargos', 
          component: () => import(/* webpackChunkName: "cargos" */ '../components/cargos_abonos/IndexCargosAbonosComponent.vue') 
        },      
        { path: 'tipoSocio',
          name:'tipoSocio', 
          component: () => import(/* webpackChunkName: "tipoSocio" */ '../components/socios/IndexCustomerType.vue') 
        },      
        { path: 'parametros',
          name:'parametros', 
          component: () => import(/* webpackChunkName: "parametros" */ '../components/parametros/IndexParametrosComponent.vue') 
        },
        {
          path:'fiscalparam',
          name:'fiscalparam',
          component:()=>import(/* webpackChunkName: "fiscaData" */ '../components/fiscal_data/FiscalDataComponent.vue') 
        },             
        { path: 'admins',
          name:'admins', 
          component: () => import(/* webpackChunkName: "employees" */ '../components/employees/IndexEmployeeComponent.vue') 
        },
        { path: 'socios',
          name:'socios', 
          component: () => import(/* webpackChunkName: "socios" */ '../components/socios/ViewSocios.vue') ,
          children:[
            { path: '',
              name:'listSocios', 
              component: () => import(/* webpackChunkName: "indexSocios" */ '../components/socios/IndexSocioComponent.vue') 
            },
            { path: 'socio/:id',
              name:'socioDetail', 
              component: () => import(/* webpackChunkName: "socioComponent" */ '../components/socios/SocioComponent.vue') 
            },
            {
              path:'socio/contrato/:id',
              name:'socioContrato',
              component:()=> import(/* webpackChunkName: "socioContractComponent" */ '../components/socios/CustomerContractComponent.vue') 
            },
            {
              path:'socio/recibos/:id',
              name:'socioRecibos',
              component:()=> import(/* webpackChunkName: "socioInvoicesComponent" */ '../components/socios/CustomerInvoicesComponent.vue') 
            }
            ,
            {
              path:'socio/recibo/:id',
              name:'socioRecibo',
              component:()=> import(/* webpackChunkName: "socioInvoiceComponent" */ '../components/socios/CustomerInvoiceDetailsComponent.vue') 
            },
            {
              path:'socio/invoicecfdi/:id',
              name:'invoicecfdi',
              component:()=>import(/* webpackChunkName: "invoicecfdiemitComponent" */ '../components/ventas/InvoiceCfdiEmitComponent.vue') 
            },
            {
              path:'socio/documentos/:id',
              name:'socioDocumentos',
              component:()=> import(/* webpackChunkName: "IndexCustomerDocumentsComponent" */ '../components/socios/documentsCostumer/IndexCustomerDocumentsComponent.vue') 
            },
            {
              path:'socio/documento/:id',
              name:'socioDocumento',
              component:()=> import(/* webpackChunkName: "CustomerDocumentComponent" */ '../components/socios/documentsCostumer/CustomerDocumentComponent.vue') 
            }
          ]
        },        
        { path: 'contratos',
          name:'contratos', 
          component: () => import(/* webpackChunkName: "contratos" */ '../components/ventas/contratos/ViewContratos.vue'),
          children:[
            { path: '',
              name:'listContratos', 
              component: () => import(/* webpackChunkName: "indexSocios" */ '../components/ventas/contratos/IndexContratos2Component.vue') 
            },
            { path: 'contrato/:id',
              name:'contratoDetail', 
              component: () => import(/* webpackChunkName: "contrato2View" */ '../components/ventas/contratos/ContratoView.vue') 
            },
            { path: 'contrato/recibos/:id',
              name:'contratoRecibosList', 
              component: () => import(/* webpackChunkName: "ContractInvoicesView" */ '../components/ventas/contratos/ContractInvoicesView.vue') 
            },
            { path: 'contrato/recibo/:id',
              name:'contratoReciboDetail', 
              component: () => import(/* webpackChunkName: "ContractInvoiceView" */ '../components/ventas/contratos/ContractInvoiceView.vue') 
            },
            {
              path:'contrato/invoicecfdi/:id',
              name:'invoicecfdi',
              component:()=>import(/* webpackChunkName: "invoicecfdiemitComponent" */ '../components/ventas/InvoiceCfdiEmitComponent.vue') 
            },
            { path: 'contrato/convenios/:id',
              name:'contratoConveniosList', 
              component: () => import(/* webpackChunkName: "ContractAgreementsView" */ '../components/ventas/contratos/ContractAgreementsView.vue') 
            },
            { path: 'contrato/convenio/:id',
              name:'contratoAgreementDetail', 
              component: () => import(/* webpackChunkName: "ContractAgreementView" */ '../components/ventas/contratos/ContractAgreementView.vue') 
            }            
          ]
        },     
        { path: 'reportes',
          name:'reportes', 
          children:[
            { path: 'edocta',
              name:'edocta', 
              component: () => import(/* webpackChunkName: "EdoCtaReportComponent" */ '../components/reportes/EdoCtaReportComponent.vue') 
            } ,
            { path: 'ingresos',
              name:'ingresos', 
              component: () => import(/* webpackChunkName: "IngresosReportComponent" */ '../components/reportes/IngresosReportComponent.vue') 
            } 
          ]
        },    
        { path: 'ej1',
          name:'ejemplo1', 
          component: () => import(/* webpackChunkName: "ejemplo1" */ '../views/shared/EjemploComponent1.vue') 
        },
        { path: 'ej2',
          name:'ejemplo2', 
          component: () => import(/* webpackChunkName: "ejemplo2" */ '../views/shared/EjemploComponent2.vue') 
        },
      ]
    }, 
    {
      name:'socio',    
      path:'/socio',      
      component: HomeSocioComponent,
      children: [              
        { path: 'miperfil',
          name:'miperfil', 
          component: () => import(/* webpackChunkName: "MiPerfilComponent" */ '../components/socio/MiPerfilComponent.vue') 
        },
        { path: 'info',
          name:'info', 
          component: () => import(/* webpackChunkName: "MisContratosView" */ '../components/socio/MisContratosView.vue'),
          children:[
            { path: '',
              name:'miscontratos', 
              component: () => import(/* webpackChunkName: "listContratos" */ '../components/socio/MisContratosComponent.vue') 
            },
            { path: 'contrato/detalle/:id',
              name:'contratoRecibosSocioList', 
              component: () => import(/* webpackChunkName: "RecibosContratoSocioComponent" */ '../components/socio/RecibosContratoSocioComponent.vue') 
            }
          ] 
        }
      ]
    },    
    {
      path: '/:catchAll(.*)*',
      name: "PageNotFound",
      component: NotFound,
    }
  ]
export function createRouterByPlatform()
{
    const router = CreateRouterVue({  
        history: CreateWebHistoryVue(/*process.env.BASE_URL*/),
        routes
        });   
    return router;
}
export async function CustomGuardWeb(to:any)
{
  const login = eAppPaths.login;  
  const loginSocio = eAppPaths.loginSocio;
  const factory = useServicesFactoryStore();
  if(!factory) return { name: login };
  const service = factory.getLoginService;  
  if(!service) return { name: login };
  
  let canAccess  = false;      
  const Sesion:ISesionApp|null = await service.getSession();
  if(to.name !== login && to.name !== loginSocio)
  {
    if(service.isFreePath(to,FreePaths))
    {
      return true;
    }
    canAccess  = service.canUserAccess(Sesion,to,RoutesRol);    
    if (!canAccess) return { name: login };     
  }
  return true;  
}
